/*
 * Copyright (c) 2022. Nedaware SL
 */

import {FilterInterface, InvalidFilterValue} from "../../api/filter-interface";
import {InternalPropertyMap} from "../basic-entity-interface/mapping-internal";

/**
 * Nedaware S.L.
 * @author David Campos Rodríguez <david.campos.r96@gmail.com>
 */

/**
 * Generates a general search over the given string (only strings are accepted)
 */
export class GeneralSearchFilter implements FilterInterface {
    dataToParams(property: InternalPropertyMap, data: any[] | any): { [p: string]: string | string[] } {
        if (typeof data !== "string") {
            throw new InvalidFilterValue(data, "only strings are accepted for general search");
        }

        return {"general-search": data};
    }
}
